<template>
  <transition name="fade">
    <div :class="['footer-container', { 'host-class': isHost }]">
      <div
        class="footer-button"
        @mouseenter="displayExitMsg = true"
        @mouseleave="displayExitMsg = false"
        @click="leaveGame"
      >
        <div class="icon-container">
          <font-awesome-icon :icon="['fas', 'door-open']" />
          <div class="icon-hover-container">
            <transition name="fade">
              <div v-show="displayExitMsg" class="icon-hover-msg">
                Exit game
              </div>
            </transition>
          </div>
        </div>
      </div>
      <div :style="{ opacity: displayGameRoomcode ? 1 : 0 }" class="footer-item">
        <div class="pill-container gameroomcode">
          {{ gameRoomcode }}
          <span
            v-if="isClipboardAPIAvailable"
            @click="copyRoomcodeToClipboard"
            class="copy-button"
          >
            <font-awesome-icon :icon="['fas', 'copy']" />
          </span>
          <div class="copied-hover-container">
            <transition name="fade">
              <div v-show="displayCopiedMessage" class="icon-hover-msg">
                Copied room code!
              </div>
            </transition>
          </div>
        </div>
      </div>
      <div :style="{ opacity: displayTimer ? 1 : 0 }" class="footer-item">
        <div class="pill-container">
          Round {{ gameState.roundIndex + 1 || 1 }}
        </div>
      </div>
      <div :style="{ opacity: displayTimer && gameState.turnIndex > -1 ? 1 : 0 }" class="footer-item left">
        <div class="pill-container">
          Turn {{ gameState.turnIndex + 1 || 1 }}
        </div>
      </div>
      <div
        class="footer-button"
        @mouseenter="setIsMouseInsideVolumeButtonToTrue"
        @mouseleave="setIsMouseInsideVolumeButtonToFalse"
        @click="toggleIsMusicMuted"
      >
        <MusicPlayer
          ref="musicPlayerInstance"
          :isMouseInsideVolumeButtonDelayed="isMouseInsideVolumeButtonDelayed"
          :isMuted="isMusicMuted"
          @mouse-entered-volume-slider="setIsMouseInsideVolumeSliderToTrue"
          @mouse-left-volume-slider="setIsMouseInsideVolumeSliderToFalse"
        />
      </div>
      <div
        v-show="!isLocalAudioMuted"
        class="footer-button"
        @mouseenter="displayMuteMicMsg = true"
        @mouseleave="displayMuteMicMsg = false"
        @click="$emit('disable-local-audio-tracks')"
      >
        <div class="icon-container">
          <font-awesome-icon :icon="['fas', 'microphone']" />
          <div class="icon-hover-container">
            <transition name="fade">
              <div v-show="displayMuteMicMsg" class="icon-hover-msg">
                Mute mic
              </div>
            </transition>
          </div>
        </div>
      </div>
      <div
        v-show="isLocalAudioMuted"
        class="footer-button"
        @mouseenter="displayUnmuteMicMsg = true"
        @mouseleave="displayUnmuteMicMsg = false"
        @click="$emit('enable-local-audio-tracks')"
      >
        <div class="icon-container">
          <font-awesome-icon :icon="['fas', 'microphone-slash']" />
          <div class="icon-hover-container">
            <transition name="fade">
              <div v-show="displayUnmuteMicMsg" class="icon-hover-msg">
                Unmute mic
              </div>
            </transition>
          </div>
        </div>
      </div>
      <div
        v-show="!isLocalVideoMuted"
        class="footer-button"
        @mouseenter="displayDisableCameraMsg = true"
        @mouseleave="displayDisableCameraMsg = false"
        @click="$emit('disable-local-video-tracks')"
      >
        <div class="icon-container">
          <font-awesome-icon :icon="['fas', 'video']" />
          <div class="icon-hover-container">
            <transition name="fade">
              <div v-show="displayDisableCameraMsg" class="icon-hover-msg">
                Disable camera
              </div>
            </transition>
          </div>
        </div>
      </div>
      <div
        v-show="isLocalVideoMuted"
        class="footer-button"
        @mouseenter="displayEnableCameraMsg = true"
        @mouseleave="displayEnableCameraMsg = false"
        @click="$emit('enable-local-video-tracks')"
      >
        <div class="icon-container">
          <font-awesome-icon :icon="['fas', 'video-slash']" />
          <div class="icon-hover-container">
            <transition name="fade">
              <div v-show="displayEnableCameraMsg" class="icon-hover-msg">
                Enable camera
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Vue from 'vue';
import MusicPlayer from '@/components/gameComponents/MusicPlayer';

export default Vue.extend({
  name: 'GameFooter',
  components: {
    MusicPlayer
  },
  props: {
    gameRoomcode: String,
    displayTimer: Boolean,
    isLocalAudioMuted: Boolean,
    isLocalVideoMuted: Boolean,
    isDemo: {
      type: Boolean,
      default: false
    },
    isHost: Boolean,
    isMusicMutedInitially: Boolean
  },
  data: () => ({
    gameState: {},
    displayExitMsg: false,
    displayGameRoomcode: false,
    isClipboardAPIAvailable: false,
    displayCopiedMessage: false,
    isMouseInsideVolumeButton: false,
    isMouseInsideVolumeButtonDelayed: false,
    isMouseInsideVolumeSlider: false,
    isMouseInsideVolumeSliderDelayed: false,
    displayMuteMicMsg: false,
    displayUnmuteMicMsg: false,
    displayDisableCameraMsg: false,
    displayEnableCameraMsg: false,
    isMusicMuted: true
  }),
  methods: {
    async copyRoomcodeToClipboard() {
      await navigator.clipboard.writeText(this.gameRoomcode);
      this.displayCopiedMessage = true;
      await setTimeout(() => {
        this.displayCopiedMessage = false;
      }, 2000);
    },
    setIsMouseInsideVolumeButtonToTrue () {
      this.isMouseInsideVolumeButton = true;
      this.isMouseInsideVolumeButtonDelayed = true;
    },
    setIsMouseInsideVolumeButtonToFalse () {
      this.isMouseInsideVolumeButton = false;
      setTimeout(() => {
        if (!this.isMouseInsideVolumeButton) {
          this.isMouseInsideVolumeButtonDelayed = false;
        }
      }, 600);
    },
    setIsMouseInsideVolumeSliderToTrue () {
      this.isMouseInsideVolumeSlider = true;
      this.isMouseInsideVolumeSliderDelayed = true;
    },
    setIsMouseInsideVolumeSliderToFalse () {
      this.isMouseInsideVolumeSlider = false;
      setTimeout(() => {
        if (!this.isMouseInsideVolumeSlider) {
          this.isMouseInsideVolumeSliderDelayed = false;
        }
      }, 600);
    },
    toggleIsMusicMuted () {
      if (this.isMouseInsideVolumeButton && !this.isMouseInsideVolumeSlider) {
        this.isMusicMuted = !this.isMusicMuted;
      }
    },
    leaveGame () {
      if (window.confirm('Are you sure you want to leave the game?')) {
        if (this.isDemo) {
          this.$router.push({
            name: 'landing'
          });
        } else {
          this.$router.push({
            name: 'home'
          });
        }
      }
    }
  },
  created: function() {
    this.isClipboardAPIAvailable = !!navigator.clipboard;
  },
  mounted: function() {
    this.isMusicMuted = this.isMusicMutedInitially;
  }
})
</script>

<style scoped lang="scss">
.footer-container {
  position: absolute;
  display: flex;
  text-align: center;
  height: max-content;
  min-width: max-content;
  left: 50%;
  bottom: 0;
  padding: 0 0.2em;
  font-size: 1.1em;
  background-color: $brand-gold;
  border-radius: 0.4em 0.4em 0 0;
  transform: translateX(-50%);
}

.footer-container.host-class {
  color: $natural-white;
  background-color: $brand-teal;
}

.footer-item {
  position: relative;
  flex: 1;
  display: flex;
  padding: 0 0.5em;
  min-width: max-content;
  justify-content: center;
  align-items: center;
  border-radius: 0.4em;
  transition: opacity 600ms ease-in;
}

.footer-item.left {
  justify-content: flex-start;
}

.icon-container {
  flex: 1;
  min-width: max-content;
  width: 1.4em;
  position: relative;
}

.pill-container {
  padding: 0.3em 0.8em;
  border-radius: 0.4em;
}

.pill-container.gameroomcode {
  color: $smoke-gray;
  background-color: $light-sand;
}

.icon-hover-container {
  position: absolute;
  top: -3em;
  left: 50%;
  pointer-events: none;
}

.copied-hover-container {
  position: absolute;
  top: -2.2em;
  left: 50%;
  pointer-events: none;
}

.icon-hover-msg {
  position: relative;
  left: -50%;
  padding: 0.3em 0.8em;
  color: $smoke-gray;
  border-radius: 0.4em;
  background-color: $baby-blue;
  white-space: nowrap;
}

.footer-button {
  display: flex;
  flex: 1;
  align-items: center;
  border-radius: 0.4em;
  padding: 0.4em;
  margin: 0.4em 0.2em;
  border: 1px solid $smoke-gray;
  cursor: pointer;
}

.footer-container.host-class > .footer-button {
  border-color: $natural-white;
}

.footer-button:hover {
  background-color: $light-gold;
}

.footer-container.host-class > .footer-button:hover {
  background-color: $light-teal;
}

.copy-button {
  cursor: pointer;
  padding-left: 0.6em;
}
</style>
